'use strict';

angular.module('far.page')
    .controller('PageViewController', function($log, FileUploader, Page, fileUploadFilters, showModalMessage, $uibModal) {
        var showFilterError = false;

        var vm = {
            initUploadUrl: initUploadUrl,
            openSlider: openSlider,
            uploader: new FileUploader({
                url: '',
                autoUpload: true,
                filters: [
                    fileUploadFilters.fileSize(),
                    fileUploadFilters.fileType()
                ],
                onSuccessItem: function (item, response) {
                    item.serverData = response;
                },
                onWhenAddingFileFailed: function(item, filter) {
                    if (showFilterError) return;

                    var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';

                    showFilterError = true;
                    var modalInstance = showModalMessage(message);
                    modalInstance.result
                        .then(function() {
                            showFilterError = false;
                        }, function() {
                            showFilterError = false;
                        });
                }
            }),
            getFileLink: function(file) {
                if (file.isUploading) {
                    return '';
                }

                if (file.isSuccess) {
                    return Routing.generate('api_upload_get_file', {'fileStorage': file.serverData.id});
                }

                return '';
            }
        };

        function initUploadUrl(id) {
            vm.uploader.url = Routing.generate('api_upload_post_mountainroute_file', {'id': id});
            vm.page = Page.get(id);
        }

        function openSlider(slide) {
            $uibModal.open({
                templateUrl: '/modals/slider/slider.html',
                controller: 'SliderController as slider',
                resolve: {
                    slides: function() {
                        return vm.page.slides_files;
                    },
                    selectedSlide: function() {
                        return slide;
                    }
                }
            });
        }

        return vm;
    });